import React from "react";

export function Badge({ ok }: { ok: boolean }) {
  return (
    <span className={ok ? "badge badge-ok" : "badge badge-down"}>
      {ok ? "Operational" : "Down"}
    </span>
  );
}
